import styled from 'styled-components'
import FontAwesome from 'components/FontAwesome'
import media from 'utils/media'
import Button from 'components/elements/Button'

export const StyledHeader = styled.header`
   width: calc(100% - 32px);
   max-width: 1370px;
   padding: 8px;
   display: flex;
   align-items: center;
   justify-content: space-between;
   background: ${({ theme }) => theme.colors.menuBg};
   box-shadow: 0 50px 111px rgba(0, 0, 0, 0.12), 0 202px 202px rgba(0, 0, 0, 0.1), 0 454px 272px rgba(0, 0, 0, 0.06),
      0 807px 323px rgba(0, 0, 0, 0.02), 0 1261px 353px rgba(0, 0, 0, 0);
   position: fixed;
   top: 24px;
   left: 50%;
   transform: translateX(-50%);
   z-index: 10;
   border-radius: 12px;
   font-weight: 450;
   ${media.greaterThan('lg')`
     top: 36px;
      width: calc(100% - 70px);
   `}
`

export const StyledMainLogo = styled.div`
   color: ${({ theme }) => (theme.darkMode ? theme.colors.white : theme.colors.menuLogo)};
   height: 18px;
   padding-left: 8px;
   cursor: pointer;
`

export const LeftSide = styled.div`
   display: flex;
   align-items: center;
   gap: 8px;
`

export const RightSide = styled.div`
   display: flex;
   align-items: center;
   gap: 8px;
`

export const StyledControlBtn = styled.button`
   border-radius: 6px;
   border-width: 1px;
   border-style: solid;
   cursor: pointer;
   display: flex;
   width: 40px;
   height: 40px;
   justify-content: center;
   align-items: center;
   border-color: ${({ theme }) => (theme.darkMode ? theme.colors.btnDarkBg : theme.colors.btnLightBg)};
   color: ${({ theme }) => (theme.darkMode ? theme.colors.btnDarkColor : theme.colors.btnLightColor)};
   background-color: ${({ theme }) => (theme.darkMode ? theme.colors.btnDarkBg : theme.colors.btnLightBg)};
   font-size: 15px;

   svg {
      display: block;
      color: inherit;
   }

   ${media.greaterThan('lg')`
      &:hover {
         background-color: ${({ theme }) =>
            theme.darkMode ? theme.colors.btnDarkBgHover : theme.colors.btnLightBgHover};
      }
   `};
`

export const StyledThemeIcon = styled(FontAwesome).attrs(({ theme }) => ({
   icon: theme.darkMode ? 'sun' : 'moon',
}))`
   display: block;
   color: inherit;
`

export const DecoratedBox = styled.div`
   padding: 20px;
   border-radius: 12px;
   background-color: ${({ theme }) => (theme.darkMode ? theme.colors.accent : theme.colors.white)};
   color: ${({ theme }) => (theme.darkMode ? theme.colors.white : theme.colors.accent)};
   box-shadow: 0px 70px 155px rgba(0, 0, 0, 0.08), 0px 282px 282px rgba(0, 0, 0, 0.07),
      0px 634px 380px rgba(0, 0, 0, 0.04), 0px 1126px 451px rgba(0, 0, 0, 0.01), 0px 1760px 493px rgba(0, 0, 0, 0);
   overflow: hidden;

   &::after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      width: 80px;
      height: 80px;
      background: ${({ theme }) => theme.colors.hotCinnamon}; // Adjust this orange color to match your design
      transform: rotate(45deg) translate(0, -90%);
      z-index: 1;
   }
`

export const StyledSpan = styled.span`
   display: inline-block;
   height: 14px;
   transform: translateY(-1px);
`

export const StyledNavButton = styled(Button)`
   padding-left: 8px;
   padding-right: 8px;

   @media (min-width: 360px) {
      padding-left: 14.5px;
      padding-right: 14.5px;
   }
`
